import { render, staticRenderFns } from "./RegularSchedule.vue?vue&type=template&id=2e5d8b1d&scoped=true&"
import script from "./RegularSchedule.vue?vue&type=script&lang=js&"
export * from "./RegularSchedule.vue?vue&type=script&lang=js&"
import style0 from "./RegularSchedule.vue?vue&type=style&index=0&id=2e5d8b1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5d8b1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDialog,VRow})
